// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_ECHO_VIBE_API_URL}`,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_BACKENED_API_KEY, // if your API uses API key
  },
  timeout: 10000, // 300 seconds
  // Send/receive ev_guest_id cookie for guest campaign conversion & claim flows
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
